import { useLocation, useNavigate, Outlet } from "react-router-dom";
import { Video, Tag, LayoutDashboard } from "lucide-react";
import { cn } from "@/lib/utils";

interface ContentTab {
  key: string;
  label: string;
  path: string;
  icon: React.ComponentType<{ className?: string }>;
}

const TABS: ContentTab[] = [
  { key: "dramas", label: "劇集管理", path: "/dramas", icon: Video },
  { key: "tags", label: "標籤管理", path: "/tags", icon: Tag },
  { key: "home-layout", label: "首頁排版", path: "/home-layout", icon: LayoutDashboard },
];

export default function ContentHubLayout() {
  const location = useLocation();
  const navigate = useNavigate();

  const activeKey =
    TABS.slice()
      .sort((a, b) => b.path.length - a.path.length)
      .find((t) => location.pathname.startsWith(t.path))?.key ?? "dramas";

  return (
    <div>
      {/* Tab nav — MainLayout 已提供 p-6,本元件不再加任何外部 padding */}
      <div className="border-b">
        <h1 className="text-xl font-semibold text-foreground mb-4">內容</h1>
        <div className="flex gap-1 -mb-px overflow-x-auto">
          {TABS.map((t) => {
            const Icon = t.icon;
            const isActive = activeKey === t.key;
            return (
              <button
                key={t.key}
                onClick={() => navigate(t.path)}
                className={cn(
                  "flex items-center gap-1.5 border-b-2 px-3 pb-3 pt-1.5 text-sm font-medium whitespace-nowrap transition-colors",
                  isActive
                    ? "border-primary text-foreground"
                    : "border-transparent text-muted-foreground hover:text-foreground hover:border-muted-foreground/30"
                )}
              >
                <Icon className="h-3.5 w-3.5" />
                {t.label}
              </button>
            );
          })}
        </div>
      </div>

      {/* 子頁面內容:MainLayout 與 hub 已提供 padding,移除子頁 AdminPage 的全部 padding 避免疊加 */}
      <div className="[&>div]:!p-0 [&>div]:!pt-4">
        <Outlet />
      </div>
    </div>
  );
}
